<template>
    <v-app-bar color="#2E7D32" style="color:white">      
      <v-btn v-if="!isLogged" dense @click="register()" small>Register</v-btn>
      <v-btn v-if="!isLogged" dense @click="login()" small>Login</v-btn>
      <v-btn v-if="!isLogged" dense @click="dashboard()" small>DashBoard</v-btn>
      <v-btn v-if="isLogged" dense @click="userDashboard()" small>DashBoard</v-btn>
      <v-btn v-if="!isLogged" dense @click="courseList()" small>Ponuka školení</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="this.$store.getters.isLogged" @click="logout()">Logout</v-btn>
    </v-app-bar>
</template>

<script>
import {mapGetters} from 'vuex'

export default ({
    setup() {
    },
    computed: mapGetters([
                'isLogged',
                'getFeedback'
            ]),
    methods: {
        register() {
          this.$router.push({name:'register', params: {}})
        },
        login() {
          this.$router.push({name:'login', params: {}})
        },
        dashboard() {
          this.$router.push({name:'dashboard', params: {}}) 
        },
        userDashboard() {
          this.$router.push({name:'user_dashboard', params: {}}) 
        },
        courseList() {
          this.$router.push({name:'course_list_public', params: {}}) 
        },
        logout() {
          this.$store.dispatch('logout')
        }
    }
})
</script>
